'use client';

import type { FC, HTMLAttributes } from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../../utils/cn';

interface TitleProps extends HTMLAttributes<HTMLHeadingElement> {
  level?: '1' | '2' | '3';
  weight?: '1' | '2' | '3';
}

const titleVariants = cva(
  'm-0 text-white leading-tight',
  {
    variants: {
      level: {
        '1': 'text-3xl',
        '2': 'text-2xl',
        '3': 'text-xl',
      },
      weight: {
        '1': 'font-medium',
        '2': 'font-semibold',
        '3': 'font-bold',
      },
    },
    defaultVariants: {
      level: '3',
      weight: '3',
    },
  },
);

const TAG_BY_LEVEL = { '1': 'h1', '2': 'h2', '3': 'h3' } as const;

export const Title: FC<TitleProps> = ({ children, level = '3', weight = '3', className, ...props }) => {
  const Tag = TAG_BY_LEVEL[level];

  return (
    <Tag className={cn(titleVariants({ level, weight }), className)} {...props}>
      {children}
    </Tag>
  );
};
